import React, { useEffect, useState, useRef, useMemo } from "react";

import _ from "lodash";

import { COUNTRIES } from "../helpers/countries";
import { useLang } from "../context/LangProvider";

const styles = {
  row: { display: "flex", gap: 8, alignItems: "center" },

  countryButton: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    width: "100%",
    height: 40,
    padding: "0 12px",
    border: "1px solid #d9d6cf",
    borderRadius: 4,
    background: "#fdfbf5",
    cursor: "pointer",
  },
  chev: { marginLeft: "auto", marginRight: 2, fontSize: 10, color: "#777" },

  dropdown: {
    position: "absolute",
    top: 44,
    left: 0,
    width: "100%",
    background: "#fff",
    border: "1px solid #e5e2dc",
    borderRadius: 6,
    boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
    zIndex: 20,
  },
  search: {
    width: "100%",
    height: 36,
    padding: "0 10px",
    border: "0",
    borderBottom: "1px solid #eee",
    outline: "none",
  },
  list: { maxHeight: 280, overflowY: "auto" },
  item: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "8px 10px",
    cursor: "pointer",
  },
  code: { color: "#555", fontSize: 12, marginLeft: 6 },
  iso: {
    color: "#999",
    fontSize: 11,
    border: "1px solid #eee",
    borderRadius: 4,
    padding: "0 4px",
    marginLeft: 8,
  },
  empty: { padding: 12, color: "#888", textAlign: "center" },

  inputWrap: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #d9d6cf",
    borderRadius: 4,
    overflow: "hidden",
    background: "#fff",
  },
  prefix: {
    padding: "0 10px",
    height: 44,
    display: "flex",
    alignItems: "center",
    borderRight: "1px solid #eee",
    color: "#555",
    background: "#faf8f4",
    fontVariantNumeric: "tabular-nums",
  },
  input: {
    flex: 1,
    height: 44,
    padding: "0 12px",
    border: "0",
    outline: "none",
    fontSize: 16,
  },

  submit: {
    height: 44,
    marginTop: 8,
    borderRadius: 4,
    border: 0,
    fontWeight: 700,
  },
  submitEnabled: { background: "#b4ada5", color: "white", cursor: "pointer" },
  submitDisabled: { background: "#cfcac2", color: "white", opacity: 0.7 },
};

const CountryDropDown = ({ onCountrySelect }) => {
  const { i18n } = useLang();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [country, setCountry] = useState({});

  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const results = useMemo(() => {
    const q = search?.toLowerCase();
    if (!q) return COUNTRIES;
    return COUNTRIES.filter(
      (c) => c.name.toLowerCase().includes(q)
      //  ||
      //   c.iso2.toLowerCase().includes(q) ||
      //   c.dialCode.includes(q)
    );
  }, [search]);

  useEffect(() => {
    function onDocClick(e) {
      if (!open) return;
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);

  return (
    <div style={styles.row}>
      <div style={{ position: "relative", width: "100%" }}>
        <button
          ref={buttonRef}
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          style={styles.countryButton}
        >
          {!_.isEmpty(country) ? (
            <>
              <span style={{ marginRight: 8 }}>{country.flag}</span>
              <span style={{ marginRight: 6, color: "#333" }}>
                {country.name}
              </span>
              <span style={{ color: "#777" }}>+{country.dialCode}</span>
            </>
          ) : (
            <span>{i18n("signup.foreigner.selectCountry")}</span>
          )}
          <span aria-hidden="true" style={styles.chev}>
            ▼
          </span>
        </button>

        {open && (
          <div ref={dropdownRef} style={styles.dropdown} role="listbox">
            <input
              autoFocus
              placeholder={i18n("signup.foreigner.searchCountry")}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={styles.search}
            />
            <div style={styles.list}>
              {results.map((c, index) => (
                <div
                  key={`${c.iso2}-${index}`}
                  role="option"
                  aria-selected={c.iso2 === country.iso2}
                  onClick={() => {
                    onCountrySelect(c);
                    setCountry(c);
                    setOpen(false);
                    setSearch("");
                  }}
                  style={{
                    ...styles.item,
                    background:
                      c.iso2 === country.iso2 ? "#f3f3f3" : "transparent",
                  }}
                >
                  <span style={{ marginRight: 8 }}>{c.flag}</span>
                  <span style={{ flex: 1 }}>{c.name}</span>
                  <code style={styles.code}>+{c.dialCode}</code>
                  <span style={styles.iso}>{c.iso2}</span>
                </div>
              ))}
              {results.length === 0 && (
                <div style={styles.empty}>{i18n("common.noMatches")}</div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CountryDropDown;
